import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorBrandSettingsCard from '../MotorBrandSettingsCard';
import { useLanguage } from '../../../../i18n/LanguageContext';

const JaluziSettings = React.memo(({
  activeTypeTab,
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  const { t } = useLanguage();
  const isAhsap = activeTypeTab === 'ahsapJaluzi';
  const extras = isAhsap ? jaluziExtras : metalJaluziExtras;
  const setExtras = isAhsap ? setJaluziExtras : setMetalJaluziExtras;

  const motorTitle = isAhsap
    ? t('productList.extraPrices.ahsapMotorTitle', 'Ahşap Jaluzi Motor ve Kumanda Ayarları')
    : t('productList.extraPrices.metalMotorTitle', 'Metal Jaluzi Motor ve Kumanda Ayarları');

  const motorSubtitle = isAhsap
    ? t('productList.extraPrices.ahsapMotorSubtitle', 'Ahşap Jaluzi siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri')
    : t('productList.extraPrices.metalMotorSubtitle', 'Metal Jaluzi siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri');

  const cardTitle = isAhsap
    ? t('productList.extraPrices.ahsapTitle', 'Ahşap Jaluzi Ek Ücretler')
    : t('productList.extraPrices.metalTitle', 'Metal Jaluzi Ek Ücretler');

  const cardSubtitle = t('productList.extraPrices.jaluziSubtitle', 'Ek hizmet ve sistem ücretleri');

  return (
    <>
      <MotorBrandSettingsCard
        title={motorTitle}
        subtitle={motorSubtitle}
        productType={activeTypeTab}
        extras={extras}
        setExtras={setExtras}
        handleSaveSettings={handleSaveSettings}
        isSavingSettings={isSavingSettings}
      />

      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className={isAhsap ? 'fas fa-sliders-h' : 'fas fa-layer-group'}></i>
            <div className="settings-card-title-text">
              <h4>{cardTitle}</h4>
              <span className="settings-card-subtitle">{cardSubtitle}</span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid">
          <div className="form-group">
            <label>
              {isAhsap
                ? t('productList.extraFields.zigil', 'Zıgıl Sistem')
                : t('productList.extraFields.zigilPiece', 'Zıgıl Sistem (Adet)')}
            </label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={extras.zigil}
                onChange={(e) => setExtras(p => ({ ...p, zigil: e.target.value }))}
                placeholder="0"
              />
              <span className="settings-input-suffix">€</span>
            </div>
          </div>

          {!isAhsap && (
            <>
              <div className="form-group">
                <label>{t('productList.extraFields.reduktorDiffM2', 'Redüktörlü Farkı (m²)')}</label>
                <div className="settings-input-wrap">
                  <input
                    type="number"
                    value={extras.reduktor}
                    onChange={(e) => setExtras(p => ({ ...p, reduktor: e.target.value }))}
                    placeholder="0"
                  />
                  <span className="settings-input-suffix">€</span>
                </div>
              </div>
              <div className="form-group">
                <label>{t('productList.extraFields.ikiCamArasiPiece', 'İki Cam Arası (Adet)')}</label>
                <div className="settings-input-wrap">
                  <input
                    type="number"
                    value={extras.ikiCamArasi}
                    onChange={(e) => setExtras(p => ({ ...p, ikiCamArasi: e.target.value }))}
                    placeholder="0"
                  />
                  <span className="settings-input-suffix">€</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default JaluziSettings;
